import {
  Button,
  Card,
  CircularProgress,
  Grid,
  Hidden,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@material-ui/core";
import {
  AddOutlined,
  DeleteOutline,
  InfoOutlined,
  VisibilityOutlined,
} from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";

import {
  CardGallery,
  ModalFacilityAround,
  ModalGallery,
  ModalPreviewSec,
  ModalUnit,
  TableFacilityAround,
  TableFasilitas,
  TableUnit,
  UploadImage,
} from "../../../../components";
import ModalFasilitasProp from "../../../../components/modals/ModalFasilitasProp";
import { getKota } from "../../../../redux/actions/KotaActions";
import {
  addDataPropDev,
  getTipePropDev,
} from "../../../../redux/actions/PropertyDevelopmentActions";
import { getProvinsi } from "../../../../redux/actions/ProvinsiActions";

const TambahData = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [submit, setSubmit] = useState(false);
  const { tipe } = useSelector(({ propertyDev }) => propertyDev);
  const [showPreviewSec, setShowPreviewSec] = useState(null);
  const { provinsi } = useSelector(({ provinsi }) => provinsi);
  const { kota } = useSelector(({ kota }) => kota);
  const [unit, setUnit] = useState(null);
  const [showUnit, setShowUnit] = useState(false);
  const [gallery, setGallery] = useState(null);
  const [showGallery, setShowGallery] = useState(false);
  const [fasilitas, setFasilitas] = useState(null);
  const [showFasilitas, setShowFasilitas] = useState(false);
  const [showSurroundingArea, setShowSurroundingArea] = useState(false);
  const [surroundingArea, setSurroundingArea] = useState(null);
  const [params, setParams] = useState({
    hero_mobile: "",
    hero_mobile_preview: "",
    hero_desktop: "",
    hero_desktop_preview: "",
    property_img: "",
    property_img_preview: "",
    name: "",
    type_code: "",
    province_code: "",
    city_code: "",
    address: "",
    lat: "",
    lng: "",
    desc_bg: "",
    desc_preview: "",
    desc_title_id: "",
    desc_title_en: "",
    desc_id: "",
    desc_en: "",
    unit: [],
    unit_title_id: "",
    unit_title_en: "",
    gallery: [],
    gallery_title_id: "",
    gallery_title_en: "",
    facilities: [],
    surroundingArea: [],
    facility_title_id: "",
    facility_title_en: "",
    cta_title_id: "",
    cta_title_en: "",
    cta_bg: "",
    cta_bg_preview: "",
    cta_subtitle_id: "",
    cta_subtitle_en: "",
    button_link: "",
    website: "",
    cta_btext_id: "",
    cta_btext_en: "",
  });
  useEffect(() => {
    dispatch(getTipePropDev({ paginate: false }));
    dispatch(getProvinsi({ paginate: false }));
  }, [dispatch]);

  const handleChange = ({ target: { value, name } }) => {
    if (name === "province_code") {
      setParams((pref) => ({
        ...pref,
        city_code: "",
      }));
      dispatch(getKota({ paginate: false, province_code: value }));
    }
    setParams((pref) => ({
      ...pref,
      [name]: value,
    }));
  };
  const handleFormSubmit = () => {
    setSubmit(true);
    addDataPropDev(params)
      .then(() => {
        showAlert("Data berhasil disimpan", true);
        setSubmit(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal menyimpan data, coba beberapa saat lagi",
          false
        );
        setSubmit(false);
      });
  };
  const showAlert = (text, success) => {
    Swal.fire({
      title: success ? "Berhasil" : "Oopss!",
      text: text,
      imageUrl: `/assets/images/icons/${
        success ? "ic_success" : "ic_error"
      }.svg`,
      imageWidth: 92,
      imageHeight: 92,
      confirmButtonText: "Ok",
      confirmButtonColor: "#0083E2",
    }).then((res) => {
      if (res.isConfirmed && success) {
        history.goBack();
      }
    });
  };
  const handleChangeFoto = (name, file) => {
    setParams((pref) => ({
      ...pref,
      [name]: file,
      [name + "_preview"]: file,
    }));
  };
  const handleSaveUnit = (data) => {
    if (data?.idx) {
      let cek = params.unit.findIndex((item) => item.idx === data.idx);
      let unit = params.unit;
      unit[cek].img = data?.img ? data.img : unit[cek].img;
      unit[cek].title_id = data.title_id;
      unit[cek].title_en = data.title_en;
      unit[cek].desc_id = data.desc_id;
      unit[cek].desc_en = data.desc_en;
      setParams((pref) => ({
        ...pref,
        unit: [...unit],
      }));
      setShowUnit(false);
    } else {
      let newUnit = {
        ...data,
        idx: Math.floor(Math.random() * 100),
      };
      setParams((pref) => ({
        ...pref,
        unit: [...pref.unit, newUnit],
      }));
      setShowUnit(false);
    }
    setUnit(null);
  };
  const handleDelUnit = (idx) => {
    let newUnit = params.unit.filter((item) => item.idx !== idx);
    setParams((pref) => ({
      ...pref,
      unit: newUnit,
    }));
  };
  const handleSaveGallery = (data) => {
    if (data?.idx) {
      let cek = params.gallery.findIndex((item) => item.idx === data.idx);
      let gallery = params.gallery;
      gallery[cek].img = data?.img ? data.img : gallery[cek].img;
      setParams((pref) => ({
        ...pref,
        gallery: [...gallery],
      }));
      setShowGallery(false);
    } else {
      let newGallery = {
        ...data,
        idx: Math.floor(Math.random() * 100),
      };
      setParams((pref) => ({
        ...pref,
        gallery: [...pref.gallery, newGallery],
      }));
      setShowGallery(false);
    }
    setGallery(null);
  };
  const handleDelGallery = (idx) => {
    let newGallery = params.gallery.filter((item) => item.idx !== idx);
    setParams((pref) => ({
      ...pref,
      gallery: newGallery,
    }));
  };
  const handleSaveFasilitas = (data) => {
    if (data?.idx) {
      let cek = params.facilities.findIndex((item) => item.idx === data.idx);
      let facilities = params.facilities;
      facilities[cek].bg_img = data?.bg_img
        ? data.bg_img
        : facilities[cek].bg_img;
      facilities[cek].icon = data?.icon ? data.icon : facilities[cek].icon;
      facilities[cek].title_id = data.title_id;
      facilities[cek].title_en = data.title_en;
      facilities[cek].desc_id = data.desc_id;
      facilities[cek].desc_en = data.desc_en;
      setParams((pref) => ({
        ...pref,
        facilities: [...facilities],
      }));
      setShowFasilitas(false);
    } else {
      let newFasilitas = {
        ...data,
        idx: Math.floor(Math.random() * 100),
      };
      setParams((pref) => ({
        ...pref,
        facilities: [...pref.facilities, newFasilitas],
      }));
      setShowFasilitas(false);
    }
    setFasilitas(null);
  };
  const handleDelFasilitas = (idx) => {
    let newFasilitas = params.facilities.filter((item) => item.idx !== idx);
    setParams((pref) => ({
      ...pref,
      facilities: newFasilitas,
    }));
  };
  const handleSaveSurroundingArea = (data) => {
    if (data?.idx) {
      let cek = params.surroundingArea.findIndex(
        (item) => item.idx === data.idx
      );
      let surroundingArea = params.surroundingArea;
      surroundingArea[cek].icon = data?.icon
        ? data.icon
        : surroundingArea[cek].icon;
      surroundingArea[cek].title_id = data.title_id;
      surroundingArea[cek].title_en = data.title_en;
      surroundingArea[cek].range = data.range;
      setParams((pref) => ({
        ...pref,
        surroundingArea: [...surroundingArea],
      }));
      setShowSurroundingArea(false);
    } else {
      let newSurroundingArea = {
        ...data,
        idx: Math.floor(Math.random() * 100),
      };
      setParams((pref) => ({
        ...pref,
        surroundingArea: [...pref.surroundingArea, newSurroundingArea],
      }));
      setShowSurroundingArea(false);
    }
    setSurroundingArea(null);
  };
  const handleDelSurroundingArea = (idx) => {
    let newSurroundingArea = params.surroundingArea.filter(
      (item) => item.idx !== idx
    );
    setParams((pref) => ({
      ...pref,
      surroundingArea: newSurroundingArea,
    }));
  };
  return (
    <div className="m-sm-30">
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={11} md={12}>
          <h3 className="fw-bold m-0">Tambah Pengembangan Properti</h3>
        </Grid>
        <Grid item xs={11} md={12}>
          <Card elevation={0} className="py-5 px-6 border-radius-0 ">
            <ValidatorForm onSubmit={handleFormSubmit} className="w-full">
              <Grid container spacing={2}>
                {/* Data Property */}
                <Grid item xs={12} md={6}>
                  <UploadImage
                    uploadFoto={(file) =>
                      handleChangeFoto("hero_desktop", file)
                    }
                    label="Unggah Foto Untuk Desktop"
                    preview={params?.hero_desktop_preview}
                    required={true}
                    noCrop={true}
                    note={[
                      "Format PNG, WEBP dan JPG diperbolehkan",
                      "*Ukuran foto 1440 x 617",
                    ]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <UploadImage
                    uploadFoto={(file) => handleChangeFoto("hero_mobile", file)}
                    label="Unggah Foto Untuk Mobile"
                    preview={params?.hero_mobile_preview}
                    noCrop={true}
                    required={true}
                    note={[
                      "Format PNG, WEBP dan JPG diperbolehkan",
                      "*Ukuran foto 767 x 500",
                    ]}
                  />
                </Grid>
                <Grid item xs={12}>
                  <UploadImage
                    uploadFoto={(file) =>
                      handleChangeFoto("property_img", file)
                    }
                    label="Unggah Foto Properti"
                    preview={params?.property_img_preview}
                    noCrop={true}
                    required={true}
                    note={[
                      "Format PNG, WEBP dan JPG diperbolehkan",
                      "*Ukuran foto 772 x 579",
                    ]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="name" className="mb-4">
                    Nama <span className="text-danger">*</span>
                  </InputLabel>
                  <TextValidator
                    id="name"
                    placeholder="Nama Properti"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="name"
                    value={params.name || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Nama Properti terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="type_code" className="mb-4">
                    Tipe <span className="text-danger">*</span>
                  </InputLabel>
                  <Select
                    size="small"
                    labelId="type_code"
                    value={params.type_code}
                    onChange={handleChange}
                    variant="outlined"
                    className="w-full"
                    name="type_code"
                    displayEmpty
                  >
                    <MenuItem value="" selected>
                      Pilih Tipe
                    </MenuItem>
                    {tipe?.map((item) => (
                      <MenuItem value={item.type_code} key={item.type_code}>
                        {item.type_id}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="province_code" className="mb-4">
                    Provinsi <span className="text-danger">*</span>
                  </InputLabel>
                  <Select
                    size="small"
                    labelId="province_code"
                    value={params.province_code}
                    onChange={handleChange}
                    variant="outlined"
                    className="w-full"
                    name="province_code"
                    displayEmpty
                  >
                    <MenuItem value="" selected>
                      Pilih Provinsi
                    </MenuItem>
                    {provinsi?.map((item) => (
                      <MenuItem
                        value={item.province_code}
                        key={item.province_code}
                      >
                        {item.province_name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="city_code" className="mb-4">
                    Kota <span className="text-danger">*</span>
                  </InputLabel>
                  <Select
                    size="small"
                    labelId="city_code"
                    value={params.city_code}
                    onChange={handleChange}
                    variant="outlined"
                    className="w-full"
                    name="city_code"
                    displayEmpty
                  >
                    <MenuItem value="" selected>
                      Pilih Kota
                    </MenuItem>
                    {kota?.map((item) => (
                      <MenuItem value={item.city_code} key={item.city_code}>
                        {item.city_name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                {/* Bagian 1 */}
                <Grid item xs={12} className="mt-6">
                  <h4 className="font-semibold">
                    Bagian 1{" "}
                    <IconButton
                      onClick={() =>
                        setShowPreviewSec(
                          "/assets/images/illustrations/prop_dev_1.png"
                        )
                      }
                      size="small"
                    >
                      <VisibilityOutlined
                        fontSize="small"
                        color="action"
                      ></VisibilityOutlined>
                    </IconButton>
                  </h4>
                </Grid>
                <Grid item xs={12}>
                  <UploadImage
                    uploadFoto={(file) => handleChangeFoto("desc_bg", file)}
                    label="Unggah Foto"
                    preview={params?.desc_bg_preview}
                    required={true}
                    noCrop={true}
                    note={[
                      "Format PNG, WEBP dan JPG diperbolehkan",
                      "*Ukuran foto 772 x 579",
                    ]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="desc_title_id" className="mb-4">
                    Judul [ID] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="desc_title_id"
                    placeholder="Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="desc_title_id"
                    value={params.desc_title_id || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="desc_title_en" className="mb-4">
                    Judul [EN] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="desc_title_en"
                    placeholder="Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="desc_title_en"
                    value={params.desc_title_en || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="desc_id" className="mb-4">
                    Deskripsi [ID] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="desc_id"
                    placeholder="Deskripsi"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="desc_id"
                    value={params.desc_id || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Deskripsi terlebih dahulu"]}
                    multiline
                    maxRows={16}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="desc_en" className="mb-4">
                    Deskripsi [EN] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="desc_en"
                    placeholder="Deskripsi"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="desc_en"
                    value={params.desc_en || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Deskripsi terlebih dahulu"]}
                    multiline
                    maxRows={16}
                  />
                </Grid>
                {/* Bagian 2 */}
                <Grid item xs={12} className="mt-6">
                  <h4 className="font-semibold">
                    Bagian 2{" "}
                    <IconButton
                      onClick={() =>
                        setShowPreviewSec(
                          "/assets/images/illustrations/prop_dev_2.png"
                        )
                      }
                      size="small"
                    >
                      <VisibilityOutlined
                        fontSize="small"
                        color="action"
                      ></VisibilityOutlined>
                    </IconButton>
                  </h4>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="unit_title_id" className="mb-4">
                    Judul [ID] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="unit_title_id"
                    placeholder="Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="unit_title_id"
                    value={params.unit_title_id || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="unit_title_en" className="mb-4">
                    Judul [EN] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="unit_title_en"
                    placeholder="Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="unit_title_en"
                    value={params.unit_title_en || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={8} md={10} className="flex items-center">
                  <h5 className="font-semibold">Data Unit</h5>
                </Grid>
                <Grid item xs={4} md={2}>
                  <Hidden xsDown>
                    <Button
                      onClick={() => setShowUnit(true)}
                      type="button"
                      variant="contained"
                      color="primary"
                      className="text-white w-full text-capitalize"
                      disableElevation
                    >
                      <AddOutlined />
                      Tambah
                    </Button>
                  </Hidden>
                  <Hidden smUp>
                    <Button
                      onClick={() => setShowUnit(true)}
                      type="button"
                      variant="contained"
                      color="primary"
                      className="text-white w-full text-capitalize"
                      disableElevation
                      size="small"
                    >
                      <AddOutlined />
                    </Button>
                  </Hidden>
                </Grid>
                <Grid item xs={12}>
                  <TableUnit
                    data={params.unit}
                    handleDelUnit={handleDelUnit}
                    setShowUnit={setShowUnit}
                    setUnit={setUnit}
                  />
                </Grid>
                {/* Bagian 3 */}
                <Grid item xs={12} className="mt-6">
                  <h4 className="font-semibold">
                    Bagian 3{" "}
                    <IconButton
                      onClick={() =>
                        setShowPreviewSec(
                          "/assets/images/illustrations/prop_dev_3.png"
                        )
                      }
                      size="small"
                    >
                      <VisibilityOutlined
                        fontSize="small"
                        color="action"
                      ></VisibilityOutlined>
                    </IconButton>
                  </h4>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="gallery_title_id" className="mb-4">
                    Judul [ID] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="gallery_title_id"
                    placeholder="Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="gallery_title_id"
                    value={params.gallery_title_id || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="gallery_title_en" className="mb-4">
                    Judul [EN] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="gallery_title_en"
                    placeholder="Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="gallery_title_en"
                    value={params.gallery_title_en || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={6} md={8} className="flex items-center">
                  <h5 className="font-semibold">Galleri</h5>
                </Grid>
                <Grid item xs={6} md={4} className="flex items-center gap-4">
                  <Hidden xsDown>
                    <Button
                      onClick={() =>
                        setParams((pref) => ({
                          ...pref,
                          gallery: [],
                        }))
                      }
                      type="button"
                      className="text-danger w-full text-capitalize"
                      disableElevation
                    >
                      <DeleteOutline />
                      Hapus Semua
                    </Button>
                  </Hidden>
                  <Hidden smUp>
                    <Button
                      onClick={() =>
                        setParams((pref) => ({
                          ...pref,
                          gallery: [],
                        }))
                      }
                      type="button"
                      className="text-danger w-full text-capitalize"
                      disableElevation
                      size="small"
                    >
                      <DeleteOutline />
                    </Button>
                  </Hidden>
                  <Hidden xsDown>
                    <Button
                      onClick={() => setShowGallery(true)}
                      type="button"
                      variant="contained"
                      color="primary"
                      className="text-white w-full text-capitalize"
                      disableElevation
                    >
                      <AddOutlined />
                      Tambah
                    </Button>
                  </Hidden>
                  <Hidden smUp>
                    <Button
                      onClick={() => setShowGallery(true)}
                      type="button"
                      variant="contained"
                      color="primary"
                      className="text-white w-full text-capitalize"
                      disableElevation
                      size="small"
                    >
                      <AddOutlined />
                    </Button>
                  </Hidden>
                </Grid>
                {params?.gallery?.length <= 0 ? (
                  <Grid item xs={12}>
                    <p className="py-2 text-center text-muted">Data Kosong</p>
                  </Grid>
                ) : (
                  params?.gallery?.map((item) => (
                    <Grid item xs={12} md={4}>
                      <CardGallery
                        img={item.img}
                        handleDel={() => handleDelGallery(item.idx)}
                        handleEdit={() => {
                          setGallery(item);
                          setShowGallery(true);
                        }}
                      />
                    </Grid>
                  ))
                )}
                {/* Bagian 4 */}
                <Grid item xs={12} className="mt-6">
                  <h4 className="font-semibold">
                    Bagian 4{" "}
                    <IconButton
                      onClick={() =>
                        setShowPreviewSec(
                          "/assets/images/illustrations/prop_dev_4.png"
                        )
                      }
                      size="small"
                    >
                      <VisibilityOutlined
                        fontSize="small"
                        color="action"
                      ></VisibilityOutlined>
                    </IconButton>
                  </h4>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="facility_title_id" className="mb-4">
                    Judul [ID] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="facility_title_id"
                    placeholder="Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="facility_title_id"
                    value={params.facility_title_id || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="facility_title_en" className="mb-4">
                    Judul [EN] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="facility_title_en"
                    placeholder="Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="facility_title_en"
                    value={params.facility_title_en || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={8} md={10} className="flex items-center">
                  <h5 className="font-semibold">Data</h5>
                </Grid>
                <Grid item xs={4} md={2}>
                  <Hidden xsDown>
                    <Button
                      onClick={() => setShowFasilitas(true)}
                      type="button"
                      variant="contained"
                      color="primary"
                      className="text-white w-full text-capitalize"
                      disableElevation
                    >
                      <AddOutlined />
                      Tambah
                    </Button>
                  </Hidden>
                  <Hidden smUp>
                    <Button
                      onClick={() => setShowFasilitas(true)}
                      type="button"
                      variant="contained"
                      color="primary"
                      className="text-white w-full text-capitalize"
                      disableElevation
                      size="small"
                    >
                      <AddOutlined />
                    </Button>
                  </Hidden>
                </Grid>
                <Grid item xs={12}>
                  <TableFasilitas
                    data={params?.facilities}
                    handleDelFasilitas={handleDelFasilitas}
                    setShowFasilitas={setShowFasilitas}
                    setFasilitas={setFasilitas}
                  />
                </Grid>
                {/* Bagian 5 */}
                {/* Fasilitas Sekitar */}
                <Grid item xs={6} md={10} className="flex items-center">
                  <h4 className="font-semibold">
                    Bagian 5{" "}
                    <IconButton
                      onClick={() =>
                        setShowPreviewSec(
                          "/assets/images/illustrations/portfolio_4.png"
                        )
                      }
                      size="small"
                    >
                      <VisibilityOutlined
                        fontSize="small"
                        color="action"
                      ></VisibilityOutlined>
                    </IconButton>
                  </h4>
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="address" className="mb-4">
                    Alamat <span className="text-danger">*</span>
                  </InputLabel>
                  <TextValidator
                    id="address"
                    placeholder="Alamat Properti"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="address"
                    value={params.address || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Alamat Properti terlebih dahulu"]}
                    multiline
                    maxRows={5}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="lat" className="mb-4">
                    Latitude <span className="text-danger">*</span>
                  </InputLabel>
                  <TextValidator
                    id="lat"
                    placeholder="Latitude Alamat Properti"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="lat"
                    value={params.lat || ""}
                    validators={["required"]}
                    errorMessages={[
                      "Masukkan Latitude Alamat Properti terlebih dahulu",
                    ]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="lng" className="mb-4">
                    Longitude <span className="text-danger">*</span>
                  </InputLabel>
                  <TextValidator
                    id="lng"
                    placeholder="Longitude Alamat Properti"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="lng"
                    value={params.lng || ""}
                    validators={["required"]}
                    errorMessages={[
                      "Masukkan Longitude Alamat Properti terlebih dahulu",
                    ]}
                  />
                </Grid>
                <Grid item xs={8} md={10} className="flex items-center">
                  <h5 className="font-semibold">Data</h5>
                </Grid>
                <Grid item xs={4} md={2} className="flex items-center gap-4">
                  <Hidden xsDown>
                    <Button
                      onClick={() => setShowSurroundingArea(true)}
                      type="button"
                      variant="contained"
                      color="primary"
                      className="text-white w-full text-capitalize"
                      disableElevation
                    >
                      <AddOutlined />
                      Tambah
                    </Button>
                  </Hidden>
                  <Hidden smUp>
                    <Button
                      onClick={() => setShowSurroundingArea(true)}
                      type="button"
                      variant="contained"
                      color="primary"
                      className="text-white w-full text-capitalize"
                      disableElevation
                      size="small"
                    >
                      <AddOutlined />
                    </Button>
                  </Hidden>
                </Grid>
                <Grid item xs={12}>
                  <TableFacilityAround
                    data={params?.surroundingArea}
                    handleDelFasilitas={handleDelSurroundingArea}
                    setFasilitas={setSurroundingArea}
                    setShowFasilitas={setShowSurroundingArea}
                  />
                </Grid>
                {/* Bagian 6 */}
                <Grid item xs={12} className="mt-6">
                  <h4 className="font-semibold">
                    Bagian 6{" "}
                    <IconButton
                      onClick={() =>
                        setShowPreviewSec(
                          "/assets/images/illustrations/prop_dev_5.png"
                        )
                      }
                      size="small"
                    >
                      <VisibilityOutlined
                        fontSize="small"
                        color="action"
                      ></VisibilityOutlined>
                    </IconButton>
                  </h4>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="cta_title_id" className="mb-4">
                    Judul [ID] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="cta_title_id"
                    placeholder="Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="cta_title_id"
                    value={params.cta_title_id || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="cta_title_en" className="mb-4">
                    Judul [EN] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="cta_title_en"
                    placeholder="Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="cta_title_en"
                    value={params.cta_title_en || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="cta_subtitle_id" className="mb-4">
                    Sub Judul [ID] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="cta_subtitle_id"
                    placeholder="Sub Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="cta_subtitle_id"
                    value={params.cta_subtitle_id || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Sub Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="cta_subtitle_en" className="mb-4">
                    Sub Judul [EN] <span className="text-danger">*</span>
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="cta_subtitle_en"
                    placeholder="Sub Judul"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="cta_subtitle_en"
                    value={params.cta_subtitle_en || ""}
                    validators={["required"]}
                    errorMessages={["Masukkan Sub Judul terlebih dahulu"]}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="cta_btext_id" className="mb-4">
                    Teks Tombol [ID]{" "}
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="cta_btext_id"
                    placeholder="Teks Tombol"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="cta_btext_id"
                    value={params.cta_btext_id || ""}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="cta_btext_en" className="mb-4">
                    Teks Tombol [EN]{" "}
                    <Tooltip
                      title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                      placement="top-start"
                      arrow
                    >
                      <InfoOutlined
                        fontSize="small"
                        color="action"
                      ></InfoOutlined>
                    </Tooltip>
                  </InputLabel>
                  <TextValidator
                    id="cta_btext_en"
                    placeholder="Teks Tombol"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="cta_btext_en"
                    value={params.cta_btext_en || ""}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="button_link" className="mb-4">
                    URL Tombol
                  </InputLabel>
                  <TextValidator
                    id="button_link"
                    placeholder="URL Tombol"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="button_link"
                    value={params.button_link || ""}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel htmlFor="website" className="mb-4">
                    URL Website
                  </InputLabel>
                  <TextValidator
                    id="website"
                    placeholder="URL Website"
                    className="w-full"
                    variant="outlined"
                    onChange={handleChange}
                    type="text"
                    name="website"
                    value={params.website || ""}
                  />
                </Grid>
                <Grid item xs={12}>
                  <UploadImage
                    uploadFoto={(file) => handleChangeFoto("cta_bg", file)}
                    label="Background Bagian CTA"
                    preview={params?.cta_bg_preview}
                    required={true}
                    noCrop={true}
                    note={[
                      "Format PNG, WEBP dan JPG diperbolehkan",
                      "*Ukuran foto 1440 x 550",
                    ]}
                  />
                </Grid>
                {/* Tombol */}
                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="flex-end"
                    className="flex-column-reverse flex-md-row"
                  >
                    <Grid item xs={12} md={2}>
                      <Button
                        color="primary"
                        className="text-primary w-full radius-6 text-capitalize py-2"
                        disableElevation
                        disabled={submit}
                        onClick={() => history.goBack()}
                      >
                        Batal
                      </Button>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className="text-white w-full radius-6 text-capitalize py-2"
                        disableElevation
                        disabled={submit}
                      >
                        {submit ? (
                          <CircularProgress color="primary" size={25} />
                        ) : (
                          "Simpan"
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </ValidatorForm>
          </Card>
        </Grid>
      </Grid>
      {showPreviewSec && (
        <ModalPreviewSec
          handleClose={() => setShowPreviewSec(null)}
          img={showPreviewSec}
          open={showPreviewSec}
        />
      )}
      {showUnit && (
        <ModalUnit
          data={unit}
          handleClose={() => {
            setShowUnit(false);
            setUnit(null);
          }}
          handleSave={handleSaveUnit}
          open={showUnit}
        />
      )}
      {showGallery && (
        <ModalGallery
          data={gallery}
          handleClose={() => {
            setShowGallery(false);
            setGallery(null);
          }}
          handleSave={handleSaveGallery}
          open={showGallery}
        />
      )}
      {showSurroundingArea && (
        <ModalFacilityAround
          data={surroundingArea}
          handleClose={() => {
            setShowSurroundingArea(false);
            setSurroundingArea(null);
          }}
          handleSave={handleSaveSurroundingArea}
          open={showSurroundingArea}
        />
      )}
      <ModalFasilitasProp
        open={showFasilitas}
        data={fasilitas}
        handleClose={() => {
          setFasilitas(null);
          setShowFasilitas(false);
        }}
        handleSave={handleSaveFasilitas}
      />
    </div>
  );
};

export default TambahData;
